import { useState } from 'react';
import { resolveMedia } from '../data/videoTemplates';
import { useSound } from '../utils/soundBus';
import { LazyVideo } from './LazyVideo';
import { SoundButton } from './SoundButton';
import { Icon } from './Icon';
import './TemplateCard.css';

const pad = (n) => String(n).padStart(2, '0');

// `paid`: only subscribers are shown which scenes are still coming soon.
// `featured`: the 2x2 bento card; wide enough on desktop to need the HQ rendition.
// `index` overrides the number on the chip when the layout shows scenes in a different order.
export function TemplateCard({ template, onOpen, order = 0, selected = false, compact = false, paid = false, featured = false, index }) {
    const media = resolveMedia(template);
    const [wide] = useState(() => featured && window.matchMedia?.('(min-width: 721px)').matches);
    const sound = useSound(`card:${template.id}`);
    const soon = paid && template.status === 'soon';

    const onKeyDown = (e) => {
        if (e.target !== e.currentTarget) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(template); }
    };

    return (
        <article
            className={`tplCard${soon ? ' tplCard--soon' : ''}${selected ? ' tplCard--selected' : ''}${compact ? ' tplCard--compact' : ''}${featured ? ' tplCard--featured' : ''}`}
            style={{ '--i': order }}
            role="button"
            tabIndex={0}
            aria-label={`${template.title}${soon ? ' — coming soon' : ''}`}
            onClick={() => onOpen(template)}
            onKeyDown={onKeyDown}
        >
            <LazyVideo
                src={wide ? media.video : media.preview}
                priority={featured}
                poster={media.poster}
                blur={media.blur}
                muted={!sound.on}
                focus={template.focus}
            />
            <span className="tplCardScrim" aria-hidden="true" />

            <span className="tplCardTop">
                <span className="tplCardIndex">{pad(index ?? template.index)}</span>
                {featured && <span className="badge tplCardFeatured">Featured</span>}
                {template.badge && <span className={`badge badge--${template.badge.toLowerCase()}`}>{template.badge}</span>}
            </span>

            <span className="tplCardBottom">
                <span className="tplCardText">
                    <span className="tplCardTitle">{template.title}</span>
                    {!compact && (
                        <span className="tplCardCta">
                            {soon ? <><Icon name="play" size={10} /> Preview</> : <>Try it <Icon name="arrowRight" size={12} strokeWidth={2.6} /></>}
                        </span>
                    )}
                </span>
                {template.audio && !compact && <SoundButton on={sound.on} onToggle={sound.toggle} />}
            </span>

            {selected && <span className="tplCardCheck"><Icon name="check" size={14} strokeWidth={3} /></span>}
        </article>
    );
}
